import React from "react";
import PropTypes from "prop-types";

var isSafari =
  typeof window !== "undefined"
    ? /constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification))
    : false;

// import { FaArrowDown } from "react-icons/fa/";
import BackgroundImage from "gatsby-background-image";

const Hero = props => {
  const { scrollToContent, backgrounds, theme } = props;
  console.log(isSafari);
  return (
    <React.Fragment>
      <BackgroundImage
        Tag="section"
        className="hero"
        fluid={isSafari ? backgrounds.desktopPng : backgrounds.desktopWebp}
        backgroundColor={theme.hero.background}
      >
        <h1>
          <strong>The Fantasy Bros</strong>
        </h1>
        <h2>Educating the common fan about Daily Fantasy Sports</h2>
        {/* <button onClick={scrollToContent} aria-label="scroll">
          <FaArrowDown />
        </button> */}
      </BackgroundImage>

      {/* --- STYLES --- */}
      <style jsx>{`
        :global(.hero) {
          align-items: center;
          background-size: cover;
          color: ${theme.text.color.primary.inverse};
          flex-flow: column nowrap;
          min-height: 100vh;
          height: 100px;
          padding: ${theme.space.inset.l};
          padding-top: ${theme.header.height.homepage};

          position: relative;
          opacity: 0.8 !important;
          display: flex;
          /* align-items: center; */
          justify-content: center;
          flex-direction: column;
          align-items: center;
          flex-wrap: nowrap;
        }

        h1 {
          text-align: center;
          font-size: ${theme.hero.h1.size};
          margin: ${theme.space.stack.l};
          color: ${theme.hero.h1.color};
          line-height: ${theme.hero.h1.lineHeight};
          text-remove-gap: both 0 "Open Sans";

          :global(strong) {
            position: relative;
            font-weight: 900;

            &::after,
            &::before {
              content: "›";
              color: ${theme.text.color.attention};
              margin: 0 ${theme.space.xs} 0 0;
              text-shadow: 0 0 ${theme.space.s} ${theme.color.neutral.gray.k};
            }
            &::after {
              content: "‹";
              margin: 0 0 0 ${theme.space.xs};
            }
          }
        }

        h2 {
          text-align: center;
          font-size: ${theme.hero.h2.size};
          margin: ${theme.space.stack.l};
          color: ${theme.hero.h2.color};
          line-height: ${theme.hero.h2.lineHeight};
          text-remove-gap: both 0 "Open Sans";

          :global(strong) {
            position: relative;

            &::after,
            &::before {
              content: "›";
              color: ${theme.text.color.attention};
              margin: 0 ${theme.space.xs} 0 0;
              text-shadow: 0 0 ${theme.space.s} ${theme.color.neutral.gray.k};
            }
            &::after {
              content: "‹";
              margin: 0 0 0 ${theme.space.xs};
            }
          }
        }

        button {
          background: ${theme.background.color.brand};
          border: 0;
          border-radius: 50%;
          font-size: ${theme.font.size.m};
          padding: ${theme.space.s} ${theme.space.m};
          cursor: pointer;
          width: ${theme.space.xl};
          height: ${theme.space.xl};

          &:focus {
            outline-style: none;
            background: ${theme.color.brand.primary.active};
          }

          :global(svg) {
            position: relative;
            top: 5px;
            fill: ${theme.color.neutral.white};
            stroke-width: 40;
            stroke: ${theme.color.neutral.white};
            animation-duration: ${theme.time.duration.long};
            animation-name: buttonIconMove;
            animation-iteration-count: infinite;
          }
        }

        @keyframes buttonIconMove {
          0% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
          100% {
            transform: translateY(0);
          }
        }

        @from-width tablet {
          .hero {
          }

          h1 {
            max-width: 90%;
            font-size: ${`calc(${theme.hero.h1.size} * 1.3)`};
          }

          button {
            font-size: ${theme.font.size.l};
          }
        }

        @from-width desktop {
          .hero {
            opacity: 0.8;
          }

          h1 {
            max-width: 80%;
            font-size: ${`calc(${theme.hero.h1.size} * 1.5)`};
          }

          button {
            font-size: ${theme.font.size.xl};
          }
        }
      `}</style>
    </React.Fragment>
  );
};

Hero.propTypes = {
  scrollToContent: PropTypes.func.isRequired,
  backgrounds: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default Hero;
